import * as React from 'react';

import { Button, Card, Typography } from '@mui/material';

import { useIntl } from '@kamernet/core/Intl';
import { NavLink } from '@kamernet/core/Routing/NavLink';
import { ROUTES } from '@kamernet/core/Routing/routes';

import { ListingDetailsContext } from '@kamernet/views/ListingDetails/ListingDetailsContext';

import styles from './LandlordPreviewMode.module.css';

export const LandlordPreviewMode = () => {
  const { T, locale } = useIntl();
  const { listingDetails } = ListingDetailsContext.useContext();

  return (
    <React.Fragment>
      <Card className={styles.card}>
        <div className={styles.cardRow}>
          <Typography variant="body2">{T('ldp.view_only_mode_lld')}</Typography>
        </div>
      </Card>
      <NavLink.Wrap
        href={ROUTES.LCFContinue.getURL(
          { listingID: listingDetails.listingId },
          locale,
        )}
      >
        <Button variant="outlined">{T('ldp.lld.edit')}</Button>
      </NavLink.Wrap>
    </React.Fragment>
  );
};
